import React from 'react';
import NavBar from '../../components/Navbar/NavBar';
import FooterOne from '../../components/Footer/Footer';
import { Box, Container, Link, Typography, useTheme, useMediaQuery } from '@mui/material';

const OverviewTab = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <Box>
            <NavBar />
            <Box
                sx={{
                    mt: 6,
                    backgroundImage: 'url("/assets/img/about/overview2.jpg")',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    height: '100vh',
                    position: 'relative',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <Typography variant={isMobile ? 'h3' : 'h1'} component="h1"
                    sx={{
                        position: 'absolute',
                        color: '#ffffff',
                        textShadow: '2px 2px 8px #000000',
                        fontWeight: 'bold',
                        fontSize: { xs: '2rem', sm: '4rem', md: '6rem' },
                    }}
                >
                    OUR PROJECTS
                </Typography>
            </Box>

            <Container sx={{ py: 5 }}>
                <Box sx={{ mb: 5, display: 'flex', flexDirection: isMobile ? 'column' : 'row', alignItems: 'center' }}>
                    <Typography variant="h6" sx={{ mr: 2, whiteSpace: 'nowrap' }}>
                        <strong>Video :</strong>
                    </Typography>
                    <Link href="https://www.youtube.com/watch?v=o4Mbh1y1mBA" target="_blank" rel="noopener noreferrer" sx={{ textDecoration: 'none' }}>
                        A Visit to the BEADS for Education High School
                    </Link>
                </Box>

                <Box sx={{ mb: 5 }}>
                    <Typography variant="h4" gutterBottom>
                        Sponsoring Girls' Education
                    </Typography>
                    <Typography>
                        In 1998, BEADS for Education started sponsoring girls' education in Kenya. A total of
                        over 500 girls are either enrolled in school now or have graduated from the program.
                        Sponsorship begins in 4th grade and continues through college.
                    </Typography>
                </Box>

                <Box sx={{ mb: 5 }}>
                    <Typography variant="h5" gutterBottom>
                        Where We Work
                    </Typography>
                    <Typography>
                        Our projects take place in three regions within Kenya. In each region, BEADS provides
                        school sponsorships, business development opportunities, and programs to improve the
                        quality of education and women's rights.
                    </Typography>
                </Box>

                {/* <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4, borderRadius: 5 }}>
                    <img src='assets/img/about/kenyamap.jpg' alt='map' style={{ maxWidth: '100%', height: 'auto' }} />
                </Box> */}

                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        mt: 4,
                        mx: isMobile ? 2 : 'auto',
                        width: isMobile ? 'auto' : '80%',
                        '& img': {
                            width: isMobile ? '100%' : 'auto',
                            maxWidth: '100%',
                            height: isMobile ? 'auto' : 400,
                            borderRadius: 5,
                            objectFit: 'contain',
                        },
                    }}
                >
                    <img src='assets/img/about/kenyamap.jpg' alt='map' />
                </Box>

            </Container>
            <FooterOne />
        </Box>
    );
};

export default OverviewTab;
